import React from "react";
// Components
import VideoCallComponent from "../../components/videoCallComponent";

const Home = () => <VideoCallComponent />;

export default Home;
